import styled from 'styled-components';

export const ContentPageSidebar = styled.div`
  > * {
    &:not(:first-child) {
      margin-top: 40px;
    }
  }
`;
